import { useCallback, useState } from 'react';

import { format, addDays } from 'date-fns';
import { HiDotsVertical } from 'react-icons/hi';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useAppBillingData } from '~/hooks/billingData';
import { BillingProps } from '~/models';
import { Program as ProgramProps } from '~/models/Billing';
import api from '~/services/api';

import Modal from '../Modal';

import {
  BillingNumber,
  BillingTrainingAmount,
  ButtonContainer,
  ButtonText,
  CardContainer,
  Container,
  ModalContainer,
  Options,
  Program,
  ProgramContainer,
  ProgramContent,
} from './styles';

type Training = {
  created_at: string;
  cycle: number;
  next_training_date: string;
  deadline: number;
  status: string;
};

type RouteParams = {
  userId: string;
};

type Props = {
  billing: BillingProps;
};

const TrainingProgramCard: React.FC<Props> = ({ billing }) => {
  const { userId } = useParams<RouteParams>();
  const { push } = useHistory();
  const { handleSaveBillingData, handleCurrentProgram } = useAppBillingData();

  const [modal, setModal] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState<number>();
  const [currentProgram, setCurentProgram] = useState<ProgramProps | null>(
    null,
  );

  const handleNavigateToProgramOfTraining = useCallback(() => {
    push(
      `/professional/students/${userId}/billing/${billing.id}/training-programs/${selectedProgram}/turbo-training`,
      currentProgram?.training_program,
    );
  }, [push, userId, billing, selectedProgram, currentProgram]);

  const handleNavigateToTrainingManagement = useCallback(async () => {
    const trainingStatusVariations = [
      {
        value: 'pendente',
        label: 'Pendente',
      },
      {
        value: 'emitido',
        label: 'Emitido',
      },
      {
        value: 'cancelado',
        label: 'Cancelado',
      },
    ];

    handleSaveBillingData(billing);
    handleCurrentProgram(currentProgram);

    const { data } = await api.get<Training>(
      `programs/${selectedProgram}/manangers/any_id`,
    );

    const selectedStatus = trainingStatusVariations.filter(
      (status) => status.value === data.status,
    )[0];

    const training = {
      ...data,
      status: selectedStatus,
    };

    push(
      `/professional/students/${userId}/billing/${billing.id}/training-programs/${selectedProgram}/training-management`,
      training,
    );
  }, [push, userId, billing, selectedProgram]);

  const statusVariations: { [key: string]: string } = {
    pending: 'Pendente',
    emited: 'Emitido',
    expired: 'Expirado',
    canceled: 'Cancelada',
    '': 'Não informado',
  };

  const ModalView: React.FC = () => (
    <Modal
      isOpen={modal}
      setOpen={setModal}
      maxWidthStyled={576}
      maxHeightStyled={279}
    >
      <ModalContainer>
        <ButtonContainer onClick={handleNavigateToProgramOfTraining}>
          <ButtonText>Programa de treino</ButtonText>
        </ButtonContainer>

        <ButtonContainer secondary onClick={handleNavigateToTrainingManagement}>
          <ButtonText secondary>Gestão de treino</ButtonText>
        </ButtonContainer>
      </ModalContainer>
    </Modal>
  );

  return (
    <Container>
      <ModalView />

      {/* <Options>
        <HiDotsVertical size={20} color="#000" />

        <div>
          <button onClick={() => console.log('gerar pdf')} type="button">
            Gerar PDF
          </button>
        </div>
      </Options> */}

      <CardContainer>
        <BillingNumber>Fatura #{billing.id ?? `-`}</BillingNumber>

        <BillingTrainingAmount>
          Quantidade de treino(s): {billing?.programs?.length || 0}
        </BillingTrainingAmount>

        <ProgramContainer>
          <ul>
            {billing.programs?.map((program, index) => (
              <Program
                key={program.id}
                onClick={() => {
                  setSelectedProgram(program.id);
                  setCurentProgram(program);

                  setModal(true);
                }}
              >
                <ProgramContent>
                  <strong>Programa:</strong>

                  <p>{program.id}</p>
                </ProgramContent>

                <ProgramContent>
                  <strong>Modelo de ficha:</strong>

                  <p>
                    {program?.training_program?.data_model || 'Não informado'}
                  </p>
                </ProgramContent>

                <ProgramContent>
                  <strong>Status do treino:</strong>

                  <p>
                    {statusVariations[program.trainingManangement.status] ??
                      program.trainingManangement.status}
                  </p>
                </ProgramContent>

                <ProgramContent>
                  <strong>Data de emissão:</strong>

                  <strong>
                    {program.trainingManangement.status === 'emited'
                      ? ` ${format(
                          addDays(
                            new Date(
                              program?.trainingManangement.delivery_date,
                            ),
                            1,
                          ),
                          'dd/MM/yyyy',
                        )}`
                      : ' - '}
                  </strong>
                </ProgramContent>
              </Program>
            ))}
          </ul>
        </ProgramContainer>
      </CardContainer>
    </Container>
  );
};

export default TrainingProgramCard;
